<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png" class="nav-icon-left"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="mission-content ac crfff">
      <div class="fs50 mt50">{{ $t('ai_ppt_title') }}</div>
      <div class="css-1asaykn mt40 ppt-wrap">
        <div class="desc-card">
          <div class="desc-text">{{ $t('ai_ppt_tips') }}</div>
        </div>

        <div class="form-card mt30">
          <div class="field">
            <div class="field-label fs24 fw7">{{ $t('Prompt') }}</div>
            <textarea class="ppt-textarea" :placeholder="$t('generateImageTips1')" v-model="description"></textarea>
          </div>

          <div class="field mt20">
            <div class="field-label fs24 fw7">{{ $t('author_tip') }}</div>
            <input class="ppt-input" type="text" :placeholder="$t('author_tip')" v-model="author" />
          </div>
        </div>

        <div class="ac mt50">
          <button class="generate-btn" @click="creatImage">
            <strong>{{ $t('Generate') }}</strong>
          </button>
        </div>

        <div class="flex chances-info-bar mt30" style="justify-content: space-between;">
          <div class="score-badge">
            <span class="fs24">{{ $t('ChancesLeft') }}</span>
            <span class="fs32 fw7 ml10">{{ score }}</span>
          </div>
          <button class="buy-btn" @click="goPurchaseChances">
            <span>{{ $t('BuyChances') }}</span>
            <img style="margin-left: 0.15rem;" width="15" src="../../static/images/buy.png">
          </button>
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 0.5rem;">×</div>
        <div class="image ac" v-if="imageShow">
          <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{ $t('downTips1') }}</div>
          <div style="margin-bottom: 20px;">{{ detail.title }}</div>
          <div class="img-tools">
            <div class="ac mt20">
              <div class="input-item mt50" style="margin-bottom: 20px;">
                <div class="input-item2">
                  <input class="input" v-model="detail.url" disabled type="" placeholder="">
                </div>
              </div>
              <button class="button fw7" style="width: 100%;" id="copycode" :data-clipboard-text="detail.url"
                      @click="copy" v-if="detail.url">
                <img style="margin-left: 10px;width: 0.35rem"
                     src="../../static/images/copy1.png"/> {{ $t('copyLink') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <button class="button mt30" @click="closeProcessDialog">{{ $t('OK') }}</button>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {
    return {
      info: {},
      imageShow: false,
      detail: {},
      description: '',
      author: '',
      score: '',
      isShow: 'bur',
      processMsg: "",
    }
  },
  watch: {},
  computed: {},
  mounted() {
    let that = this;
  },
  created() {
    this.getHome();
    if (localStorage.getItem('lang')) {
      this.isShow = localStorage.getItem('lang')
    }
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    creatImage() {
      var that = this;
      let data = {
        description: that.description,
        author: that.author,
      }
      if (!that.description) {
        that.$utils.alertText(that.$t('generateImageTips1'), 50);
        return;
      }
      if (!that.author) {
        that.$utils.alertText(that.$t('author_tip'), 50);
        return;
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/product/create_ppt', data, r => {
        that.$parent.loadModal(false);
        that.getHome();
        if (r.code == 1) {
          that.description = ''
          that.author = ''
          that.$refs.processDialog.showMaskFun();
          that.processMsg = r.msg
        }else{
          that.$utils.alertText(r.msg,50);
        }
      })
    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    closeProcessDialog() {
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
  }
}
</script>
<style scoped>
.ppt-wrap {
  padding: 0.5rem 0.3rem;
  text-align: left;
}
.desc-card {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.22rem;
  padding: 0.25rem 0.24rem;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18);
}
.desc-text {
  font-size: 0.26rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.88);
}
.form-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.22rem;
  padding: 0.22rem;
}
.field-label {
  color: rgba(255, 255, 255, 0.92);
  margin-bottom: 0.12rem;
}
.ppt-textarea, .ppt-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.15rem;
  padding: 0.25rem 0.3rem;
  color: #fff;
  font-size: 0.28rem;
  box-sizing: border-box;
  outline: none;
}
.ppt-textarea {
  height: 2.4rem;
  resize: none;
  line-height: 1.5;
}
.ppt-input {
  height: 0.9rem;
}
.ppt-textarea:focus, .ppt-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(26, 75, 169, 0.8);
  box-shadow: 0 0 0 2px rgba(26, 75, 169, 0.2);
}
.generate-btn {
  width: 90%;
  height: 0.9rem;
  background: linear-gradient(135deg, #1A4BA9 0%, #0d2e6e 100%);
  color: #fff;
  border-radius: 0.45rem;
  border: none;
  font-size: 0.32rem;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(26, 75, 169, 0.4);
  cursor: pointer;
  transition: all 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.generate-btn:active {
  transform: scale(0.96);
  box-shadow: 0 2px 10px rgba(26, 75, 169, 0.4);
}
.chances-info-bar {
  display: flex;
  width: 100%;
  margin: 0 auto 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.12rem 0.22rem;
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.14rem;
}
.score-badge {
  display: flex;
  align-items: center;
  color: #fff;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
}
.score-badge span {
  white-space: nowrap;
}
.score-badge span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.buy-btn {
  background: #1A4BA9;
  border: none;
  color: #fff;
  padding: 0.12rem 0.24rem;
  border-radius: 0.3rem;
  font-size: 0.24rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(26, 75, 169, 0.3);
  -webkit-tap-highlight-color: transparent;
  flex: 0 1 48%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
}
.buy-btn span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.buy-btn img {
  flex: 0 0 auto;
}
.buy-btn:active {
  transform: scale(0.95);
}
.table-cate {
  flex-wrap: wrap;
  border: none;
  width: 100%
}

.table-cate span {
  border: 0.02rem solid #b03fa1;
  margin: 0 0.1rem 0.2rem;
  width: calc(50% - 0.2rem);
  border-radius: 0.1rem !important;
  padding: 0.15rem 0.1rem
}

.tab-content {
  flex-wrap: wrap;
  margin: 0.2rem 0 0;
  text-align: left;
  border-top: 0.02rem solid #6240da;
  padding-top: 0.2rem;
}

.tab-c {
  background: #001586;
  margin: 0.1rem;
  color: #ffffff;
  padding: 5px 0.1rem;
  display: inline-block;
  border: 1px solid #6240da;
  border-radius: 0.1rem;
}

.tab-c.active {
  background: #b03fa1;
}

.score-badge .fs24 {
  line-height: 2.35;
  padding: 0.02rem 0;
}
</style>



// WEBPACK FOOTER //
// src/page/aiPpt.vue